import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { ButtonLink } from "@/components/Buttons/index";
import { ProfilePasscodeForm } from "@/components/Form/index";
import ProfileIconImage from "@/components/Images/ProfileIconImage";
import Loading from "@/components/Loading";
import {
  useAccountSendProfilePinResetTokenMutation,
  useAuthSelectProfileMutation,
  useAuthUserQuery,
  useNotification,
  usePreviousPath,
  useRequireLogin,
} from "@/hooks";
import { PROFILE_MAX } from "@/lib/constants";
import routes from "@/lib/routes";
import styles from "@/styles/Profile.module.scss";
import { useRouter } from "next/router";
import { useCallback, useEffect, useReducer } from "react";

const initializeValue = {
  selectedProfile: null,
  passcodeInput: false,
  editProfileSelect: false,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initializeValue;
    case "edit":
      return { ...state, editProfileSelect: action.value };
    case "set":
      return {
        ...state,
        selectedProfile: action.profile,
        passcodeInput: action.profile.needPasscode,
      };
  }
};
export default function SelectProfile({ type, backToPrevPath = false }) {
  useRequireLogin();
  const { showNotification } = useNotification();

  const prevPath = usePreviousPath();
  const router = useRouter();
  const [state, dispatch] = useReducer(reducer, initializeValue);
  const {
    data: { user },
  } = useAuthUserQuery();
  const [
    select,
    { data: selectProfileData, loading, error },
  ] = useAuthSelectProfileMutation({
    onCompleted: () => {
      if (type === "switch") {
        if (backToPrevPath) {
          window.location.href = prevPath || routes.home;
        } else {
          window.location.href = routes.home;
        }
      }
    },
    // update: (cache) => {
    //   cache.evict({ fieldName: "userFavorites" });
    //   cache.evict({ fieldName: "feavoritesByConentType" });
    //   cache.evict({ fieldName: "getViewingHistory" });
    //   cache.gc();
    // },
    onError: (e) => console.log(e), // Uncaught Errorになるのでここでハンドリングする
  });

  useEffect(() => {
    if (type !== "switch" && user && user.profiles.length === 1) {
      const profile = user.profiles[0];
      if (profile.needPasscode) {
        dispatch({ type: "set", profile });
      } else {
        select({ variables: { profileId: profile.id } });
      }
    }
  }, [type, user]);

  const handleClick = useCallback(
    (profile) => {
      return () => {
        if (state.editProfileSelect) {
          router.push(routes.profileEdit(profile.id));
        } else if (profile.needPasscode) {
          dispatch({ type: "set", profile });
        } else {
          select({ variables: { profileId: profile.id } });
        }
      };
    },
    [state.editProfileSelect]
  );

  const handleEdit = useCallback(() => {
    if (state.editProfileSelect) {
      dispatch({ type: "edit", value: false });
    } else {
      dispatch({ type: "edit", value: true });
    }
  }, [state.editProfileSelect]);

  const [sendProfilePinResetToken] = useAccountSendProfilePinResetTokenMutation(
    {
      onCompleted: ({ sendProfilePinResetToken }) => {
        if (sendProfilePinResetToken?.result) {
          showNotification("暗証番号リセットメールをお送りしました", {
            time: 2000,
          });
        }
      },
    }
  );
  const resetPin = useCallback(() => {
    sendProfilePinResetToken();
  }, []);

  const handleBack = useCallback(() => dispatch({ type: "reset" }), []);

  const onSubmit = useCallback((data) => {
    select({
      variables: {
        profileId: Number(data.id),
        passcode: data.passcode,
        type: "auth",
      },
    });
  }, []);

  const isOwner = user?.currentProfile?.ownerProfile;

  if (selectProfileData) return null;
  return (
    <div className={styles.select}>
      {loading && <Loading fixed />}
      {!loading && state.passcodeInput && (
        <ProfilePasscodeForm
          profile={state.selectedProfile}
          back={handleBack}
          onSubmit={onSubmit}
          error={error}
          resetPin={resetPin}
          type="auth"
        />
      )}
      {!loading && !state.selectedProfile && !state.passcodeInput && (
        <>
          <h2>
            {!state.editProfileSelect && "ご利用されるプロフィールを選択"}
            {state.editProfileSelect &&
              "編集するプロフィールを選択してください。"}
          </h2>
          <div className={styles.profiles}>
            {user &&
              user.profiles.map((profile) => (
                <div
                  key={`profile-icon-${profile.id}`}
                  className={styles.profileItem}
                >
                  <ProfileIconImage
                    {...profile}
                    onClick={handleClick(profile)}
                  />
                  {/* {profile?.id == user.currentProfile?.id && <span>選択中</span>} */}
                </div>
              ))}
          </div>
          {type == "switch" && isOwner && (
            <div className={styles.btns}>
              <div className={styles.btn}>
                <ButtonLink
                  href={routes.profileAdd}
                  borderGray
                  medium
                  disabled={user && user.profiles.length >= PROFILE_MAX}
                >
                  プロフィールの追加
                </ButtonLink>
              </div>
              <div className={styles.btn}>
                <ButtonMultiClick borderGray medium onClick={handleEdit}>
                  {state.editProfileSelect && "キャンセル"}
                  {!state.editProfileSelect && "プロフィールの編集"}
                </ButtonMultiClick>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
